var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCkeckimage = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9.895,
  height: 7.961,
  viewBox: "0 0 9.895 7.961",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:{props.stroke};stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M544.581,289.811l1.977,2.439,5.528-4.333",
  transform: "matrix(0.985, -0.174, 0.174, 0.985, -585.402, -186.792)"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCkeckimage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ckeckimage.cf1b48b2.svg";
export { ForwardRef as ReactComponent };